import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { async } from 'rxjs';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';
import { ApiService } from './../../../../../Services/api.service';
import { CommonServices } from './../../../../../Services/common.service';

@Component({
  selector: 'g10-employee-booking-reports',
  templateUrl: './employee-booking-reports.component.html',
  styleUrls: ['./employee-booking-reports.component.css']
})
export class EmployeeBookingReportsComponent implements OnInit {


  public matFormSize = '12px';
  public filterForm: FormGroup;

  public noDataFoundEnable: boolean = false;
  public excelData = {};

  public maxDate = new Date(new Date().setHours(24));
  public maxEndDate = new Date(new Date().setHours(24));
  public defaultMaxDate = new Date(new Date().setHours(24));

  public localStorage;
  public errorObject: any = {
    startDate: '',
    endDate: '',
  }
  public formSubmitted: boolean = false;


  pageNum = 1;
  public routeType = '';
  public exlNoDataFound = false;
  public employeeExlData = [];
  public EmployeeData = [



    // {
    //     "vehRegNo": "DL58RT8674",
    //     "seatNo": 15,
    //     "tripDate": 1647973800000,
    //     "route": "Open Book Route1",
    //     "name": "Mathan M"
    // },
    // {
    //     "vehRegNo": "DL58RT8674",
    //     "seatNo": 16,
    //     "tripDate": 1648060200000,
    //     "route": "Open Book Route1",
    //     "name": "Sarvesh"
    // },
    // {
    //     "vehRegNo": "DL65AP6655",
    //     "seatNo": 1,
    //     "tripDate": 1647993600000,
    //     "route": "open booking test1",
    //     "name": "Mathan M"
    // }
  ]

  /* Pagination */
  public userPaginationData: any;
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  public filterData = {};

  public showTable: boolean = false;
  public tableData: any = [];

  // {
  //   key: 'tripDate', display: 'Trip date', config: {
  //     isDate: true,
  //     format: 'dd/MM/YYYY'
  //   }, minWidth: '80px',
  //   headerConfig:{ isDefault: true}
  // },



  public cols: any = [
    { key: '#', display: '#', minWidth: '60px' },
    {
      key: 'tripDate', display: 'Trip date', minWidth: '80px',
      headerConfig: { isDefault: true }
    },
    {
      key: 'name', display: 'Employee name',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 40,
          concatVal: '...',
        }
      },
      headerConfig: { isDefault: true }
    },
    {
      key: 'empRefID', display: 'Employee ID',
      config: {
        isUppercase: true,
      },
      minWidth: '75px',
      headerConfig: { isDefault: true }
    },
    {
      key: 'routeName', display: 'Route name',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 25,
          concatVal: '...',
        }
      },
      headerConfig: { isDefault: true }
    },
    {
      key: 'vehRegNo', display: 'Reg no',
      config: {
        isVehicle: true,
      }, minWidth: '90px',
      headerConfig: { isDefault: true }
    },
    {
      key: 'ppName', display: 'Pickup point name',
      config: {
        isTruncate: true,
        truncateData: {
          limit: 40,
          concatVal: '...',
        }
      },
      headerConfig: { isDefault: true }
    },
    {
      key: 'transitMode', display: 'Transit mode', minWidth: '80px',
      headerConfig: { isDefault: true }
    },

    // {
    //   key: 'ppEta', display : 'ETA'
    // },

    {
      key: 'createdAt', display: 'Booked date & time', config: {
        isDate: true,
        format: 'dd/MM/YYYY hh:mm:ss'
      },
      headerConfig: { isDefault: true },
      minWidth: '140px'
    },
    { key: 'seatNo', display: 'Seat', minWidth: '35px' },
    { key: 'isActive', display: 'Status' },
  ];

  public showDownloadBtn: boolean = false;
  public empDetails: any = {};
  public routeDetails: any = {};
  public ppDetails: any = {};

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private api: ApiService,
    private storage: StorageService,
    private com: CommonServices,
    private fb: FormBuilder,
    public excel: ExcelExportService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.userPaginationData = this.storage.get('pagination') ? this.storage.get('pagination') : null;
    //  this.getRouteINfo();

  }

  ngOnInit(): void {
    this.getBookingDayConfigData();
    this.filterFormLoad();
    if (this.userPaginationData != undefined && this.userPaginationData['tpmEmpBookReport']) {
      this.getEmployeeReports(this.userPaginationData['tpmEmpBookReport']['page'], this.userPaginationData['tpmEmpBookReport']['limit']);
    }
    else {
      setTimeout(() => { this.getEmployeeReports(); }, 1000);
    }
  }

  getBookingDayConfigData() {
    this.api.transportManagerGblSetBookingDayConfigList({}).then((res: any) => {
      if (res && res.status == 'success') {
        if (res.data && res.data[0]) {
          let dayCount = res.data[0] && res.data[0].dayCount ? res.data[0].dayCount : 1;
          this.setDateMax(dayCount)
        }
      }
    }).catch((err) => {
      console.log('error', err);
    })
  }

  setDateMax(days) {

    let noOfHours = 24 * (+days);
    // this.maxDate = new Date(new Date().setHours(noOfHours));

    let currentMonthDays = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
    let day = new Date().getDate();
    let balanceDaysInThisMonth = currentMonthDays - day;
    var d = new Date();
    let dt = new Date(d.setMonth(d.getMonth() + 1));
    let nextMonthDays = new Date(new Date(dt).getFullYear(), new Date(dt).getMonth() + 1, 0).getDate();
    let totalDays = balanceDaysInThisMonth + nextMonthDays;
    // this.maxEndDate = new Date(new Date().setHours(noOfHours));
    var lastDate = new Date();
    lastDate.setDate(lastDate.getDate() + totalDays);
    this.maxDate = lastDate;
    this.maxEndDate = lastDate;
    this.defaultMaxDate = lastDate;
  }

  getEmployeeReports(page = 1, limit = 10, filter?) {
    let obj = {
      page: page,
      limit: limit,
    };
    if (filter) {
      obj = { ...obj, ...filter };
      this.filterData = { ...filter };
    }

    this.api.getEmployeeBookingReports(obj).then(async (res: any) => {
      if (res && res['status'] == 'success') {
        if (res['data'] && res['data'].length > 0) {

          this.EmployeeData = res['data'];
          if (res['empInfo'] && Object.keys(res['empInfo']).length > 0) {
            Object.keys(res['empInfo']).map((item) => {
              this.empDetails[item] = res['empInfo'][item];
            })
          }
          if (res['routeInfo'] && Object.keys(res['routeInfo']).length > 0) {
            Object.keys(res['routeInfo']).map((item) => {
              this.routeDetails[item] = res['routeInfo'][item];
            })
          }
          if (res['ppInfo'] && Object.keys(res['ppInfo']).length > 0) {
            Object.keys(res['ppInfo']).map((item) => {
              this.ppDetails[item] = res['ppInfo'][item];
            })
          }
          this.processTableData();
          this.processPagination(res, obj);
        }
        else {
          this.tableData = [];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
      }
      else {
        this.tableData = [];
        this.showTable = true;
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log('err', err);
    })

  }

  processTableData() {
    this.showTable = false;
    this.tableData = this.EmployeeData.map((res: any) => {
      let obj = {
        // tripDate: res.tripDate,
        tripDate: this.com.timestampToDate(res.tripDate, 'DMY'),
        name: this.empDetails[res.employeeID] && this.empDetails[res.employeeID]['name'] ? this.empDetails[res.employeeID]['name'] : '',
        empRefID: this.empDetails[res.employeeID] && this.empDetails[res.employeeID]['empRefID'] ? this.empDetails[res.employeeID]['empRefID'] : '',
        vehRegNo: res.vehRegNo,
        seatNo: res.seatNo,
        routeName: this.routeDetails[res.routeID] && this.routeDetails[res.routeID] ? this.routeDetails[res.routeID] : '',
        transitMode: res['trasitMode'] ? res['trasitMode'] : '',
        ppName: res['pickuppointID'] && this.ppDetails[res['pickuppointID']] && this.ppDetails[res['pickuppointID']]['name'] ? this.ppDetails[res['pickuppointID']]['name'] : '',
        ppEta: res['pickuppointID'] && this.ppDetails[res['pickuppointID']] && this.ppDetails[res['pickuppointID']]['eta'] ? this.ppDetails[res['pickuppointID']]['eta'] : '',
        createdAt: res.createdAt,
        employeeID: res.employeeID,
        isActive: res['isActive'] == 1 ? '<img src="../../../../../../assets/images/user/tick.png" title="Booked" width="20 ">'
          : '<img src="../../../../../../assets/images/user/cross.png" title="Cancelled" width="20 ">',
      }
      return obj;
    });
    setTimeout(() => { this.showTable = true; this.noDataFoundEnable = true; }, 100);
  }


  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.storage.setData({ pagination: { ...this.userPaginationData, 'tpmEmpBookReport': this.paginationData } });
    this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    let filterObj = Object.keys(this.filterData).length > 0 ? this.filterData : false;
    this.getEmployeeReports(data.page, data.limit, filterObj);  // (data.page,data.limit,'search') use third parameter to get results for search inputs
  }

  getEmployeeExlReports(obj) {
    this.showDownloadBtn = false;
    this.employeeExlData = [];
    this.empDetails = {};
    this.api.getEmployeeBookingExlReports(obj).then(async (res: any) => {
      if (res && res.data && res.data.length > 0) {
        this.employeeExlData = res.data;
        if (Object.keys(res['empInfo']).length > 0) {
          Object.keys(res['empInfo']).map((item) => {
            this.empDetails[item] = res['empInfo'][item];
          });
        }
        if (res['routeInfo'] && Object.keys(res['routeInfo']).length > 0) {
          Object.keys(res['routeInfo']).map((item) => {
            this.routeDetails[item] = res['routeInfo'][item];
          })
        }
        if (res['ppInfo'] && Object.keys(res['ppInfo']).length > 0) {
          Object.keys(res['ppInfo']).map((item) => {
            this.ppDetails[item] = res['ppInfo'][item];
          })
        }

        setTimeout(() => {
          this.exportToExcel();
        }, 500);

      } else {
        this.exlNoDataFound = true;
      }
    }).catch((err) => { console.log(err); this.exlNoDataFound = true; })
  }

  filterFormLoad() {
    this.filterForm = this.fb.group({
      // vehicle: new FormControl('', [Validators.required]),
      search: new FormControl(''),
      startDate: new FormControl('', [Validators.required]),
      endDate: new FormControl('', [Validators.required]),
    });
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.filterForm.controls[type].patchValue(x.getTime());
    });
  }

  setMaxDate() {
    let t_maxDate = new Date(this.filterForm.controls.startDate.value);

    //add a day to the date
    t_maxDate.setDate(t_maxDate.getDate() + 30);

    if (this.defaultMaxDate > t_maxDate) {
      this.maxEndDate = t_maxDate;
    } else {
      this.maxEndDate = this.defaultMaxDate;
    }
  }

  validation(data) {
    let objectKeys = Object.keys(this.errorObject);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['endDate'] = 'Invalid end date';
        }
      }
    }
    return isValid;
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  onSubmit() {
    // console.log(this.sosForm.value);
    this.formSubmitted = true;
    let checkObj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    let isValid = this.validation(checkObj);
    console.log(isValid);
    if (isValid) {
      let obj = {
        startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
        endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
      }
      if (this.filterForm.value.search != '') obj['search'] = this.filterForm.value.search;
      this.getEmployeeExlReports(obj);
      this.getEmployeeReports(1, this.paginationData.limit, obj);
    }
  }

  async exportToExcel() {
    let data = [];

    const startDate = new Date(this.filterForm.value.startDate + '');
    const endDate = new Date(new Date(this.filterForm.value.endDate + '').setHours(23, 59, 59));

    for (let i = 0; i < this.employeeExlData.length; i++) {
      let item = this.employeeExlData[i];
      try {
        let res = {
          value: [
            i + 1,
            item.tripDate ? this.com.timestampToDate(new Date(item.tripDate).getTime(), 'DMY') : '--/--/----',
            item.employeeID && this.empDetails[item.employeeID] && this.empDetails[item.employeeID]['name'] ? this.empDetails[item.employeeID]['name'] : '---',
            item.employeeID && this.empDetails[item.employeeID] && this.empDetails[item.employeeID]['empRefID'] ? this.empDetails[item.employeeID]['empRefID'] : '---',
            item.routeID && this.routeDetails[item.routeID] ? this.routeDetails[item.routeID] : '---',
            item.vehRegNo ? item.vehRegNo : '---',
            item.pickuppointID && this.ppDetails[item.pickuppointID] && this.ppDetails[item.pickuppointID]['name'] ? this.ppDetails[item.pickuppointID]['name'] : '---',
            item.trasitMode ? item.trasitMode : '---',
            item.pickuppointID && this.ppDetails[item.pickuppointID] && this.ppDetails[item.pickuppointID]['eta'] ? this.ppDetails[item.pickuppointID]['eta'] : '--:--',
            item.createdAt ? this.com.timestampToDate(new Date(item.createdAt).getTime(), 'DMY H:M:S') : '--/--/----',
            item.seatNo ? item.seatNo : '---',
            item.isActive == 1 ? 'Booked' : 'Cancelled',]
        };
        data.push(res);

      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {

      let customizedData = [];

      let titleRow = {
        value: ['Employee Booking Report'],
        mergeCells: ["A1:L2"],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        alignment: {
          cell: "A1", value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: '966462AF' }
        },
      }

      customizedData.push(titleRow);

      let subtitleRow = {
        value: ["Start Date  : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
          "End Date    : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY')],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: ["A3:L4"],
      }

      customizedData.push(subtitleRow);

      let headerRow =
      {
        value: ['S No', 'Trip date', 'Employee name', 'Employee ID', 'Route name', 'Reg no', 'Pickup point name', 'Transit mode', 'ETA', 'Booked date & time', 'Seat number', 'Status'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData = [...customizedData, ...data];

      const excelInfo = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 15 }, { colNo: 3, width: 25 }, { colNo: 4, width: 20 }, { colNo: 5, width: 35 }, { colNo: 6, width: 15 }, { colNo: 7, width: 35 }, { colNo: 8, width: 15 }, { colNo: 9, width: 15 }, { colNo: 10, width: 25 }, { colNo: 11, width: 15 }, { colNo: 12, width: 20 }]
        }
      };

      if (this.excelData['Employee_Booking_Report'] == undefined) { this.excelData['Employee_Booking_Report'] = {}; }

      this.excelData['Employee_Booking_Report'] = excelInfo;
      this.exlNoDataFound = false;
      this.showDownloadBtn = true;
    }
    else this.exlNoDataFound = true;

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Employee_Booking_Report.xlsx');
  }


}
